export default __webpack_public_path__ + "static/media/volkihar-enderal-logo.1dfaa83b.png";